import generalLedgerAccounts from './general-ledger-accounts.js';
import generalLedgers from './general-ledgers.js';
import journalEntries from './journal-entries.js';
import recurringJournalEntries from './recurring-journal-entries.js';
import recurringJournalEntryBatch from './recurring-journal-entry-batches.js';
import journalEntryBatches from './journal-entry-batches.js';
import trialBalances from './trial-balances.js';
import assets from './asset.js';
import accruedExpenses from './accrued-expenses.js';
import accruedRevenues from './accrued-revenues.js';
import prepaidExpenses from './prepaid-expenses.js';
import deferredRevenues from './deferred-revenues.js';
import dimensions from './dimensions.js';

export default [
    ...generalLedgerAccounts,
    ...generalLedgers,
    ...journalEntries,
    ...journalEntryBatches,
    ...recurringJournalEntries,
    ...recurringJournalEntryBatch,
    ...trialBalances,
    ...assets,
    ...accruedExpenses,
    ...accruedRevenues,
    ...prepaidExpenses,
    ...deferredRevenues,
    ...dimensions,
];
